const initialState = {
  modalType: null,
  modalProps: {}
}

const SHOW   = 'SHOW_MODAL';
const HIDE = 'HIDE_MODAL';

export default function modal(state = initialState, action) {
  switch (action.type) {
    case 'SHOW_MODAL':
      return {
        modalType: action.modalType,
        modalProps: action.modalProps
      }
    case 'HIDE_MODAL':
      return initialState
    default:
      return state
  }
}

export function showModal(modalType, modalProps = {}) {
  return { type: SHOW, modalType, modalProps };
}

export function hideModal() {
  return { type: HIDE };
}


// WEBPACK FOOTER //
// ./src/actions/modal.js